import {DrawerProps} from '@mantine/core';
import {RecordForm} from "../forms/RecordForm.tsx";
import {ProductLineItem} from "../types.ts";
import {PlatformDrawer} from '@flexinet/ui-components';

export const FormDrawer = (
    {
        record,
        handleSubmit,
        opened,
        onClose,
        ...rest
    }: DrawerProps & {
        record: ProductLineItem,
        handleSubmit: (values: ProductLineItem) => void
    }) => {

    const title = record?.id ? `Edit Product Line Item` : `Add Product Line Item`;

    const handleFormSubmit = async (values: ProductLineItem) => {
        const payload = {
            ...values,
            productId: values.productId || record.productId
        };
        await handleSubmit(payload);
        onClose();
    };

    return (
        <PlatformDrawer
            opened={opened}
            onClose={onClose}
            title={title}
            {...rest}
        >
            <RecordForm
                record={record}
                handleSubmit={handleFormSubmit}
                handleCancel={onClose}
            />
        </PlatformDrawer>
    )
};
